export const FPN_DOCUMENT_URL = '/documents/FairProcessingNotice-VMFULLPNV16.pdf?external=true',
  VM_SECURITY_URL = 'https://uk.virginmoney.com/virgin/security.jsp?external=true',
  RETRIEVED_SAVE_APPLICATION = 'https://uk.virginmoney.com/personal-loans/your-application',
  UNEMPLOYED_STATUS = 'UNEMPLOYED',
  SELF_EMPLOYED_STATUS = 'SELF EMPLOYED';
